/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimExternalDocumentResponseDto } from '../models/clm-claim-external-document-response-dto';
import { ClmExternalDocumentDto } from '../models/clm-external-document-dto';


/**
 * the ClaCreateClaimDocument API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaCreateClaimDocumentService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimExternalClaimIdDocumentPost
   */
  static readonly ClaimExternalClaimIdDocumentPostPath = '/claim/external/{claimId}/document';

  /**
   * The possibility to upload a document to a claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimExternalClaimIdDocumentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimExternalClaimIdDocumentPost$Response(params: {
    claimId: string;
    tpaCode?: string;
    body: ClmExternalDocumentDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimExternalDocumentResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaCreateClaimDocumentService.ClaimExternalClaimIdDocumentPostPath, 'post');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.query('tpaCode', params.tpaCode, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimExternalDocumentResponseDto>;
      })
    );
  }

  /**
   * The possibility to upload a document to a claim.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimExternalClaimIdDocumentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimExternalClaimIdDocumentPost(params: {
    claimId: string;
    tpaCode?: string;
    body: ClmExternalDocumentDto
  },
  context?: HttpContext

): Observable<ClmClaimExternalDocumentResponseDto> {

    return this.claimExternalClaimIdDocumentPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimExternalDocumentResponseDto>) => r.body as ClmClaimExternalDocumentResponseDto)
    );
  }

}
